// metamask
export const SET_REF_ABOUT = "SET_REF_ABOUT";
export const SET_REF_ROADMAP = "SET_REF_ROADMAP";
export const SET_REF_TEAM = "SET_REF_TEAM";
export const SET_BALANCE_TOKEN = "SET_BALANCE_TOKEN";
